import styled from "styled-components";

export const StyledPage = styled.div`
  padding-top: 3.6rem;
  .Polaris-Header-Title__TitleWrapper {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
  .Polaris-Page-Header__Row {
    align-items: center;
    .Polaris-Page-Header__RightAlign {
      align-self: center;
    }
  }
  // .tabs-content {
  //   margin-top: 2.5rem;
  // }
  .Polaris-Page-Header {
    margin-bottom: 3rem;
    &.Polaris-Page-Header--hasNavigation {
      display: flex;
      align-items: center;
      .Polaris-Page-Header__Navigation {
        margin-right: 1.5rem;
        display: flex;
        align-items: center;
        .Polaris-Button {
          display: flex;
          align-items: center;
          .Polaris-Icon {
            vertical-align: middle;
          }
        }
      }
    }
    .Polaris-Header-Title__TitleMetadata {
      margin-top: 0;
      margin-bottom: 0.7rem;
    }
  }
  .Polaris-Header-Title {
    font-size: 1.75rem;
    line-height: 1.2;
    display: flex;
    align-items: center;
  }
  .help-text {
    display: flex;
    padding: 0.7rem 1rem;
    .Polaris-Icon {
      margin-right: 1rem;
    }
  }

  .Polaris-Header-Title__TitleMetadata {
    vertical-align: top;
    margin-top: 0.5rem;
  }

  .Polaris-Header-Title {
    line-height: 1.2;
    display: flex;
    align-items: center;
  }
`;

export const LoadingWrapper = styled.div`
  background-color: #fff;
  .Polaris-SkeletonDisplayText__DisplayText {
    max-width: none;
    height: 5.7rem;
  }
`;
